import React from 'react'
import { connect } from 'react-redux'

import Skills from '../Skills/Skills'

const default_width = 900

const DesignRoute = ({dimensions}) => {
	return(
		<div className='blackBackground poppins-regular'>
			<div style={{height:200}}></div>
			<Skills width={default_width} dimensions={dimensions} />
		</div>
	)
}

// export default DesignRoute

const mapStateToProps = (state) => ({
	dimensions: state.dimensions.dimensions,
	modal: state.modal.modal,
})
const mapDispatchToProps = (dispatch) => ({
	// increment: () => dispatch({type: 'INCREMENT' }),
	// decrement: () => dispatch({type: 'DECREMENT' }),
	modelClicked: (e) => dispatch({type: 'MODAL_CLICKED', payload: e }),
})

export default connect(mapStateToProps, mapDispatchToProps)(DesignRoute)